let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l6SzY")).then(() => parcelRequire('24TL8'));